<svg class="svg-icon" aria-hidden="true" :style="{width: size, height: size}"><use :xlink:href="`#icon-${type}`" :fill="color"></use></svg>